module.exports = __webpack_public_path__ + "img/draggable-handle.c6cc37ae.svg";